<template>
  <div>
    <b-navbar toggleable="sm" type="dark" variant="dark">
        <b-navbar-brand class="px-4" href="#" style="font-weight: bold">BUILD IT</b-navbar-brand>
        <b-navbar-toggle  class="ms-auto me-3" target="nav-collapse">
            <template #default="{ expanded }">
        <b-icon v-if="expanded" icon="arrow-bar-up"></b-icon>
        <b-icon v-else icon="arrow-bar-down"></b-icon>
      </template>
        </b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav id="navBarRightItems" class="ms-lg-auto  items">
        <b-nav-item>Newsletter (In progress)</b-nav-item>
        <!-- Navbar dropdowns -->
        <b-nav-item-dropdown  text="Langue" right>
          <b-dropdown-item href="#">Français</b-dropdown-item>
          <b-dropdown-item href="#">Anglais (In progress)</b-dropdown-item>
          <b-dropdown-item href="#">Ewe (In progress)</b-dropdown-item>
        </b-nav-item-dropdown>

        <!-- <b-nav-item-dropdown text="Utilisateur" right>
          <b-dropdown-item href="#">Compte</b-dropdown-item>
          <b-dropdown-item href="#">Paramètre</b-dropdown-item>
        </b-nav-item-dropdown> -->

      </b-navbar-nav>
        </b-collapse>
      
    </b-navbar>
  </div>
</template>

<script>

export default {
  name: "Navbar",

  data() {
    return {
      timestamp: "",
    };
  },
  
};
</script>
<style src="./navbar.scss" lang="scss" scoped/>
